/**
 * PageTransition.tsx — Transición universal entre pantallas
 *
 * Cada vez que cambia la ruta (login → menú, menú → facturas, etc.)
 * cubre la pantalla con el lienzo del tema activo (--sn-fondo) y el logo de
 * SisNetel parpadeando durante un instante, y luego revela la pantalla nueva.
 *
 * Se coloca una sola vez dentro del <Router> en App.tsx.
 */

import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import logoIso from '../assets/sisnetelp.png';
import './PageTransition.css';

// Duración del overlay en ms (logo visible parpadeando)
const TRANSITION_MS = 900;

const PageTransition: React.FC = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const firstLoad = useRef(true);

  useEffect(() => {
    // No mostrar en la primera carga: el Login ya tiene su propio splash
    if (firstLoad.current) {
      firstLoad.current = false;
      return;
    }
    setVisible(true);
    const t = setTimeout(() => setVisible(false), TRANSITION_MS);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return (
    <div className={`pt-overlay${visible ? ' pt-overlay--show' : ''}`} aria-hidden="true">
      <img src={logoIso} alt="" className="pt-logo" />
    </div>
  );
};

export default PageTransition;
